export default __webpack_public_path__ + "static/media/bunny-showcase-1.fc79c91e.png";